export const FETCH_TAGS = 'TAGS/FETCH_REQUEST';
export const FETCH_TAGS_SUCCESS = 'TAGS/FETCH_SUCCESS';

export const FETCH_TAG = 'TAG/FETCH_REQUEST';
export const FETCH_TAG_SUCCESS = 'TAG/FETCH_SUCCESS';

export const CREATE_TAG = 'TAG/CREATE_REQUEST';
export const CREATE_TAG_SUCCESS = 'TAG/CREATE_SUCCESS';
export const CREATE_TAG_FAILURE = 'TAG/CREATE_FAILURE';

export const UPDATE_TAG = 'TAG/UPDATE_REQUEST';
export const UPDATE_TAG_SUCCESS = 'TAG/UPDATE_SUCCESS';
export const UPDATE_TAG_FAILURE = 'TAG/UPDATE_FAILURE';

export const DELETE_TAG = 'TAG/DELETE_REQUEST';
export const DELETE_TAG_SUCCESS = 'TAG/DELETE_SUCCESS';
export const DELETE_TAG_FAILURE = 'TAG/DELETE_FAILURE';

export const CLONE_TAG = 'TAG/CLONE_REQUEST';
export const CLONE_TAG_SUCCESS = 'TAG/CLONE_SUCCESS';
export const CLONE_TAG_FAILURE = 'TAG/CLONE_FAILURE';

export const SET_TAGS_DASHBOARD_FILTER = 'TAGS/DASHBOARD/FILTER/SET';
export const SET_TAGS_DASHBOARD_FILTERS = 'TAGS/DASHBOARD/FILTERS/SET';
export const CLEAR_TAGS_DASHBOARD_FILTERS = 'TAGS/DASHBOARD/FILTERS/CLEAR';
export const REMOVE_TAGS_DASHBOARD_FILTER = 'TAGS/DASHBOARD/FILTER/REMOVE';

export const TAG_DETAILS_READY = 'TAG/DETAILS/READY';

export const PERSISTED_ACTION_TYPES = [
  SET_TAGS_DASHBOARD_FILTER,
  SET_TAGS_DASHBOARD_FILTERS,
  CLEAR_TAGS_DASHBOARD_FILTERS,
  REMOVE_TAGS_DASHBOARD_FILTER,
];
